import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { getDiaries } from "../api.js";
import { Loading, Diary } from "../components";

export function RootPage() {
  const [diaries, setDiaries] = useState(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const perPage = 5;
  const page = +query.get("page") || 1;
  
  useEffect(() => {
    getDiaries({ limit: 3 }).then((data) => {
      setDiaries(data);
    });
  }, []);

  return (
    <>
      <div className="block">
        {diaries == null ? (
          <Loading />
        ) : ( 
          <>
            <div className="block">
              {diaries.diaries.rows.map((diary) => {
                return <Diary key={diary.id} diary={diary} />;
              })}
            </div>
            
          </>
        )}
      </div>
      <div className="block">
        <Link to="/diaries">
          全ての記事を見る
        </Link>
      </div>
    </>
  );
}